import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-update-vendor',
  templateUrl: './update-vendor.component.html',
  styleUrls: ['./update-vendor.component.css']
})
export class UpdateVendorComponent implements OnInit {

  editForm: any | FormGroup
  product:any = []
  name = ""
  version = ""
  code = ""
  description = ""
  isActive = false
  i: any;
  deleteId: any = "";
  vendorId: any = "";
  cid:any

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getallVendor()
    this.editForm = this.fb.group({
      name: [''],
      version: [''],
      group:[''],
      code:[''],
      description:['']
    })  
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallVendor()
  }

  // addVendor(){
  //   let body = {
  //     "version": String(this.form.get('version').value),
  //     "isActive": true,
  //     "description":String(this.form.get('description').value),
  //     "code": String(this.form.get('code').value),
  //     "name": String(this.form.get('name').value),
  //     "status": "string"
  //     }

  //   console.log(body)
  //   this.generic_service.addVendor(body).subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.getallVendor()
  //       this.toastr.success(response.message);
  //       this.cancelModel()
  //     },
  //     (err:any)=>{
  //       console.log(err)
  //       this.toastr.error(err.errors[0].description);
  //     },
  //   )
  // }

  updateVendor(){
    let body = {
      "vendorMasterId": this.vendorId,
      "version": String(this.editForm.get('version').value),
      "isActive": true,
      "description":String(this.editForm.get('description').value),
      "code": String(this.editForm.get('code').value),
      "name": String(this.editForm.get('name').value),
      "status": "",
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.updateVendor(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getallVendor()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallVendor(){
    // this.generic_service.getVendor().subscribe(
    //   (response:any)=>{
    //     this.product = response.response;
    //   }
    // )
  }

  getVendorById(id:any){
    this.vendorId = id
    this.generic_service.getVendorById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          version: response.response.version,
          description: response.response.description,
          code: response.response.code
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

}